export * from './detalhes-do-projeto'
export * from './extracao-padrao'
export * from './extracoes'
export * from './geo-veles-layout'
export * from './pagina-inicial'
export * from './projetos'
export * from './recortes-do-projeto'